const cepLength = 8;

export function CepValidator(valor) {
    if (!valor) return { valido: true };

    const cep = String(valor).replace(/\D/g, '');

    if (cep.length !== cepLength) {
        return { valido: false, reason: 'length' };
    }

    if (/^0{8}$/.test(cep)) {
        return { valido: false, reason: 'zeros' };
    }

    return { valido: true };
}
